import { render, staticRenderFns } from "./tousuBack.vue?vue&type=template&id=7304678a&scoped=true&"
import script from "./tousuBack.vue?vue&type=script&lang=js&"
export * from "./tousuBack.vue?vue&type=script&lang=js&"
import style0 from "./tousuBack.vue?vue&type=style&index=0&id=7304678a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7304678a",
  null
  
)

export default component.exports